import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import {
  TransactionsPharmacyTable,
} from "../components/Tables";

export default () => {
  return (
    <>
      <div className="flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Avijo</Breadcrumb.Item>
            <Breadcrumb.Item active>Facility List</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex flex-wrap justify-content-between align-items-center w-100 gap-2">
            <h4 className="mb-0">Facility List</h4>
            <Link to="/PharmacyCreate" className="btn-primary py-2 px-2 rounded">
              Create Facility
            </Link>
          </div>
        </div>
      </div>

      <TransactionsPharmacyTable />
    </>
  );
};
